import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroupUI from "@material-ui/core/RadioGroup";
import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import * as variables from "src/styles/variables.scss";

const StyledRadio = withStyles({
    checked: {},
    root: {
        "& svg": {
            height: "16px",
            width: "16px",
        },
        "&$checked": {
            color: "#1b63dc",
        },
    },
})(Radio);

const StyledFormControlLabel = withStyles({
    label: {
        color: variables.colorDark,
        "font-size": "14px",
    },
})(FormControlLabel);

export interface RadioInputOption {
    label: string;
    value: string;
}

interface RadioGroupProps {
    options: RadioInputOption[];
    onChange: (value: any) => any;
    name: string;
    value?: RadioInputOption["value"];
    displayInRow?: boolean;
}

interface RadioGroupState {
    selected: string;
}

class RadioGroup extends Component<RadioGroupProps, RadioGroupState> {
    constructor(props: RadioGroupProps) {
        super(props);
        this.state = {
            selected: "",
        };
    }

    public componentWillMount() {
        const { value, options } = this.props;
        const found = options.find((op) => op.value === value);
        this.setState({
            selected: found ? found.value : options[0] ? options[0].value : "",
        });
    }

    public render() {
        const { options, name, displayInRow = true } = this.props;
        const { selected } = this.state;
        return (
            <RadioGroupUI name={name} value={selected} onChange={this.handleChange} row={displayInRow}>
                {options.map((op) => (
                    <StyledFormControlLabel
                        key={op.value}
                        value={op.value}
                        control={<StyledRadio />}
                        label={op.label}
                    />
                ))}
            </RadioGroupUI>
        );
    }

    private handleChange = (e: any) => {
        const val = e.target.value;
        this.setState({ selected: val });
        this.props.onChange({
            target: { value: val, name: this.props.name },
        });
    };
}

export default RadioGroup;
